import { createContext, useContext } from "solid-js";
import { createStore } from "solid-js/store";
import { Confirmer } from "@/components/ui/Confirmer";

const ConfirmerContext = createContext();

const initialState = {
  URL: '',
  show: false,
  data: {},
  text: '',
  message: '',
  title: '',
  confirm: false,
  callback: () => { }
}

export default function ConfirmerProvider(props) {
  const [confirmer, setConfirmer] = createStore(initialState);

  let cb = () => { };

  const onConfirmerClose = () => {
    setConfirmer("show", false);
  }

  const onConfirmCallback = () => {
    cb();
  }

  function showConfirmer(url, data, title, message, callback = () => { }, button = 'Confirm', confirm = false, text = '') {
    setConfirmer("URL", url);
    setConfirmer("data", data);
    setConfirmer("title", title);
    setConfirmer("message", message);
    setConfirmer("confirm", confirm);
    setConfirmer("text", text);
    setConfirmer("button", button);
    setConfirmer("show", true);
    cb = callback;
    setConfirmer("callback", () => { callback() });
  }

  return (
    <ConfirmerContext.Provider
      value={{
        showConfirmer
      }}
    >
      {props.children}
      <Confirmer url={confirmer.URL} button={confirmer.button} show={confirmer.show} callback={() => onConfirmCallback() } data={confirmer.data} onClose={() => { onConfirmerClose() }} message={confirmer.message} title={confirmer.title} confirm={confirmer.confirm} text={confirmer.text} />
    </ConfirmerContext.Provider>
  );
}

export const useConfirmer = () => useContext(ConfirmerContext);
